import React from 'react';

const docsContext = React.createContext();

export const DocsProvider = docsContext.Provider;
export default docsContext;
